module.exports = __webpack_public_path__ + "media/images/photos/5-6c67a3e01ad789c246f543770a76b0ea.jpg";